var _rect, _rect2, _path, _path2, _path3, _rect3, _rect4, _path4, _path5, _path6, _rect5, _rect6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerMosaicoTriplo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 499,
    viewBox: "0 0 430 499",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 0.5,
    width: 194,
    height: 210,
    rx: 9.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 0.5,
    width: 194,
    height: 210,
    rx: 9.5,
    stroke: "#767D8C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.25 72.25H87.75C83.6079 72.25 80.25 75.6079 80.25 79.75V132.25C80.25 136.392 83.6079 139.75 87.75 139.75H140.25C144.392 139.75 147.75 136.392 147.75 132.25V79.75C147.75 75.6079 144.392 72.25 140.25 72.25Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.875 98.5C103.982 98.5 106.5 95.9816 106.5 92.875C106.5 89.7684 103.982 87.25 100.875 87.25C97.7684 87.25 95.25 89.7684 95.25 92.875C95.25 95.9816 97.7684 98.5 100.875 98.5Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M147.75 117.25L129 98.5L87.75 139.75",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 219.5,
    y: 0.5,
    width: 194,
    height: 210,
    rx: 9.5,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 219.5,
    y: 0.5,
    width: 194,
    height: 210,
    rx: 9.5,
    stroke: "#767D8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M343.25 72.25H290.75C286.608 72.25 283.25 75.6079 283.25 79.75V132.25C283.25 136.392 286.608 139.75 290.75 139.75H343.25C347.392 139.75 350.75 136.392 350.75 132.25V79.75C350.75 75.6079 347.392 72.25 343.25 72.25Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M303.875 98.5C306.982 98.5 309.5 95.9816 309.5 92.875C309.5 89.7684 306.982 87.25 303.875 87.25C300.768 87.25 298.25 89.7684 298.25 92.875C298.25 95.9816 300.768 98.5 303.875 98.5Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M350.75 117.25L332 98.5L290.75 139.75",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 219.5,
    width: 397,
    height: 279,
    rx: 9.5,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 219.5,
    width: 397,
    height: 279,
    rx: 9.5,
    stroke: "#767D8C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M241.25 325.25H188.75C184.608 325.25 181.25 328.608 181.25 332.75V385.25C181.25 389.392 184.608 392.75 188.75 392.75H241.25C245.392 392.75 248.75 389.392 248.75 385.25V332.75C248.75 328.608 245.392 325.25 241.25 325.25Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M201.875 351.5C204.982 351.5 207.5 348.982 207.5 345.875C207.5 342.768 204.982 340.25 201.875 340.25C198.768 340.25 196.25 342.768 196.25 345.875C196.25 348.982 198.768 351.5 201.875 351.5Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M248.75 370.25L230 351.5L188.75 392.75",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerMosaicoTriplo);
export default __webpack_public_path__ + "static/media/bannerMosaicoTriplo.0cc909d0ce6763bc6f459c8ba6a5ff58.svg";
export { ForwardRef as ReactComponent };